import { CssBaseline } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import Layout from "../Layouts/Layout";
import HomeJson from "../Pages/HomeJson";
import Table from "../Pages/Table";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomeJson />} />
          <Route path="show-data" element={<Table />} />
        </Route>
      </Routes>
      <CssBaseline />
    </>
  );
}

export default App;
